import { render } from "./HomeNavigator.vue?vue&type=template&id=3c95b7f4&lang=pug"
import script from "./HomeNavigator.vue?vue&type=script&lang=js"
export * from "./HomeNavigator.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__